import React from 'react';
import PropTypes from 'prop-types';
import { sanitizePhoneNumber, phoneNumberURI } from '../../utils/phone-number';
import ResponseTap from '../response-tap';
import LinkHandler from '../link-handler';

import {
  Distance,
  ShopBody,
  ShopContent,
  ShopHeading,
  ShopItemIcon,
  ShopItemWrapper,
} from './styles';

/**
 * Displays short details of a shop, linking to that shop page
 */
const ShopListing = ({
  last = false,
  navigation,
  name,
  contactNumber,
  address,
  distance,
  responseTapClass,
}) => (
  <ShopItemWrapper>
    <ShopItemIcon width="20px" />
    <ShopBody $last={last}>
      <ShopHeading>
        <LinkHandler link={navigation}>{name}</LinkHandler>
      </ShopHeading>
      {contactNumber && (
        <ShopContent>
          <span aria-hidden="true">Tel:</span>{' '}
          <a
            href={phoneNumberURI(contactNumber)}
            aria-label={`Contact the shop at ${sanitizePhoneNumber(
              contactNumber
            )}`}
          >
            {responseTapClass ? (
              <ResponseTap rtId={responseTapClass}>{contactNumber}</ResponseTap>
            ) : (
              contactNumber
            )}
          </a>
        </ShopContent>
      )}
      <ShopContent>{address}</ShopContent>
      {distance && <Distance>{`${distance.toFixed(1)} miles away`}</Distance>}
    </ShopBody>
  </ShopItemWrapper>
);

ShopListing.propTypes = {
  /** Used for determining styling of the last listing */
  last: PropTypes.bool,
  navigation: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  contactNumber: PropTypes.string,
  address: PropTypes.string.isRequired,
  distance: PropTypes.number,
  responseTapClass: PropTypes.string,
};

export default ShopListing;
